import * as go from 'gojs';
import { getImageBananaScreen } from 'unitData/BananaScreen/getImageBananaScreen';
import {
  getDeckPortPanel,
  makeNode,
  getIOPort,
  getImageBinding,
} from '../../utils';

const alignScreenPort = (
  mirrored: boolean,
  portIndex: number,
  decks?: number,
) => {
  const x = mirrored ? 0 : 1;

  if (decks === 1) {
    switch (portIndex) {
      case 0:
        return new go.Spot(x, 5 / 6);
      case 1:
        return new go.Spot(0.5, 1);
    }
  } else if (decks === 2) {
    switch (portIndex) {
      case 0:
        return new go.Spot(x, 4 / 6);
      case 1:
        return new go.Spot(x, 5 / 6);
      case 2:
        return new go.Spot(0.5, 1);
    }
  }
};

const BananaScreenTemplate = makeNode(
  getImageBinding('nbrOfDecks', getImageBananaScreen),
  [
    getDeckPortPanel(0, alignScreenPort),
    getDeckPortPanel(1, alignScreenPort),
    getDeckPortPanel(2, alignScreenPort, (node) => node.nbrOfDecks >= 2),
    getIOPort(go.Spot.Top, 'input'),
  ],
);

export default BananaScreenTemplate;
